import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: "#00c853",
    height: 'clamp(20px, 2.2vw, 36px)',
    width: 'clamp(20px, 2.2vw, 36px)',
  },
  differenceIcon: {
    color: colors.green[900]
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  }
}));

const Strength = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={1} style={{marginRight: 30}}>
            <Avatar className={classes.avatar}><FitnessCenterIcon /></Avatar>
          </Grid>
          <Grid item xs={10}>
            <Typography
              style={{color: "#002D55", marginBottom: 5}}
              gutterBottom
              variant="h5"
            >
              STRENGTH
            </Typography>
            <Typography
              style={{marginTop: 5, marginBottom: 5}}
              color="textSecondary"
              gutterBottom
              variant="h7"
            >
              See how much you have improved the strength of your body tissue to increased resistance. 
            </Typography>
            <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowUpwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            12%
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Since last month
          </Typography>
        </Box>
          </Grid>
        </Grid>
        
      </CardContent>
    </Card>
  );
};

Strength.propTypes = {
  className: PropTypes.string
};

export default Strength;